<div class="ui-autocomplete" [class.ui-autocomplete--disabled]="disabled">
  @if (label) {
    <label class="ui-autocomplete__label">{{ label }}</label>
  }

  <div class="ui-autocomplete__field">
    <input
      class="ui-autocomplete__input"
      type="text"
      [placeholder]="placeholder"
      [disabled]="disabled"
      [value]="query()"
      role="combobox"
      [attr.aria-expanded]="open()"
      (input)="onInput($event)"
      (focus)="onFocus()"
      (blur)="onBlur()"
    />
    <span class="ui-autocomplete__chevron" aria-hidden="true">
      <ui-icon [name]="open() ? 'chevron-up' : 'chevron-down'" size="sm" />
    </span>
  </div>

  @if (open()) {
    <ul class="ui-autocomplete__list" role="listbox">
      @for (option of filtered(); track option.value) {
        <li>
          <button
            type="button"
            class="ui-autocomplete__option"
            role="option"
            (mousedown)="select(option)"
          >
            {{ option.label }}
          </button>
        </li>
      } @empty {
        <li class="ui-autocomplete__empty">Aucun résultat</li>
      }
    </ul>
  }

  @if (hint && !error) {
    <p class="ui-autocomplete__hint">{{ hint }}</p>
  }
  @if (error) {
    <p class="ui-autocomplete__error">{{ error }}</p>
  }
</div>
